import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import reveal from '../../../common/hoc/reveal';
import withTimeTrackingEnabled from './withTimeTrackingEnabled';
import { getActiveShop, getBarberUser } from '../../../auth/selectors';
import { syncTimeTrack, startTimer, stopTimer, getTimeTrackEntry } from '../actions';

const mapStateToProps = state => ({
  shop: getActiveShop(state),
  barber: getBarberUser(state),
});

const mapDispatchToProps = { syncTimeTrack, startTimer, stopTimer };

const withTimeTrackingSync = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTimeTrackingEnabled,
  withHandlers({
    syncTimeTrack: props => async (update) => {
      const ownerId = update.barberId || update.shopId;
      const ownerType = update.barberId ? 'barber' : 'shop';
      if (props.barber && update.barberId !== props.barber.id) {
        return;
      }

      const entry = await getTimeTrackEntry(update.timeTrackId, ownerId, ownerType);
      console.log('Sync time track fetched entry', entry);
      if (ownerType === 'barber' && !props.barber) {
        props.syncTimeTrack(entry, ownerId, ownerType);
        return;
      }

      if (entry.active) {
        props.startTimer(entry);
        return;
      }

      props.stopTimer(entry);
    },
  }),
);

export default reveal(['syncTimeTrack'], withTimeTrackingSync);
